export default __webpack_public_path__ + "static/media/teachers-and-kids-coloring_book_energy.dfda98a1.jpg";